import {FC, useEffect} from "react";
import {Flex} from "antd";
import {EventsTable} from "../../components/EventsTable/EventsTable.tsx";
import {useEvents} from "../../queries/useEvents.ts";
import {useOwnProfile} from "../../stores/OwnProfileStore.ts";
import {useNavigate} from "react-router";

export const DraftsPage: FC = () => {
    const { data: events, isLoading, refetch } = useEvents('drafts');

    const { profile } = useOwnProfile();
    const navigate = useNavigate();
    useEffect(() => {
        if(profile?.role === 'fir_reader') navigate('/processing');
    }, [profile]);

    return (
        <Flex vertical gap={16} flex="1 0" style={{ width: '100%' }}>
            <EventsTable
                events={events}
                loading={isLoading}
                onUpdate={refetch}
            />
        </Flex>
    );
}